import React, { Fragment, useContext } from 'react';

import { UserContext } from '../Contexts/UserContext/UserContext.js';
import { satoshis_to_eur } from '../helpers/convert_bsv_tokens.js';
import { get_explorer_url_from_txhash, getLog } from '../helpers/helpers.js';



/**
 * Displays content & adds additional info about a tx: bsv fee & explorer url
 * 
 * props:
 * 		- txstate, a txstate with .bsvfee and .hash
 * 		- children (normal react children a jsx)
 */
export default function SuccessTxSender(props) {
	const function_id = "Success_useTxSender: "
	const userContext = useContext(UserContext)
	const log = getLog(function_id)

	const txstate = props.txstate
	const bsvfee = txstate.bsvfee

	var token_url = get_explorer_url_from_txhash(txstate.hash, userContext.network);

	var fees_euro = null
	if (userContext.bsvprice && bsvfee) {
		fees_euro = satoshis_to_eur(bsvfee, userContext.bsvprice)
		if (isNaN(fees_euro)) fees_euro = null // safety check, happened before
	}
	else {
		console.error(function_id + "cannot calculate fees_euro from bsvfee=" + String(bsvfee)
			+ " & bsvprice=" + String(userContext.bsvprice))
	}

	log("token_url=", token_url,
		"\n fees_euro=", fees_euro, " = bsvfee=", bsvfee, "* bsvprice=", userContext.bsvprice
	)

	return (
		<Fragment>
			{props.children} <br /><br />

			{fees_euro ?
				<Fragment>
					Frais: {fees_euro}€ <br /><br />
				</Fragment>
				: null}

			<a href={token_url} target="_blank"><u>
				Voir la transaction sur un explorateur Blockchain 🔗
			</u></a>
		</Fragment>
	);
}
